export const USER_ORG_LOGIN_LIST = "users/org/login/list";
